import React, { type FC } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Checkbox from "../../../../../../shared-components/css-modules/lexus/molecules/Checkbox";
import styles from "./WinterWheelFitting.module.scss";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../../../../redux/store";
import { formatPriceIntl } from "../../../../../../../../common-deprecated/priceUtils";
import type { WinterWheelType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import { setWinterWheel } from "../../../../../redux/slices/CarConfigBasketSlice";
import { trackWinterWheelFitting } from "../../../../../utils/tracking";
import { CarConfigLabel, useCarConfigLabel } from "../../../../../utils/labelUtils";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const WinterWheelFitting: FC<{
    winterWheel: WinterWheelType | null;
    installTheWheels: boolean;
    setIncludeInstallation: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ winterWheel, installTheWheels, setIncludeInstallation }) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const dispatch = useDispatch<CarConfigDispatchType>();
    let checkBoxLabel = useCarConfigLabel(
        winterWheel?.installationCost ? "carConfigWinterWheelsCheckboxWithPrice" : "carConfigWinterWheelsCheckbox",
    );

    // Don't render it if no winter wheel is selected
    if (!winterWheel) return null;

    if (winterWheel.installationCost) {
        checkBoxLabel = checkBoxLabel.replace(
            "{price}",
            formatPriceIntl(commonSettings, winterWheel.installationCost.cash).primaryPrice,
        );
    }

    return (
        <div className={styles.fitting}>
            <Text tag="h2" variant="apheleia-list-item-small" className={styles.title} spacing="spacing-1">
                <CarConfigLabel label="carConfigWinterWheelsFittingTitle" />
            </Text>
            <Text tag="p" variant="apheleia-body" spacing="spacing-2" className={styles.description}>
                <CarConfigLabel label="carConfigWinterWheelsFittingDescription" />
            </Text>
            <Checkbox
                label={checkBoxLabel}
                checked={installTheWheels}
                onChange={() => {
                    dispatch(setWinterWheel({ ...winterWheel, installTheWheels: !installTheWheels }));
                    setIncludeInstallation(!installTheWheels);
                    trackWinterWheelFitting(!installTheWheels);
                }}
            />
        </div>
    );
};

export default WinterWheelFitting;
